import {MinimalHero} from "../index.js";
import {DefaultHero} from "../index.js";

export const heroComponentMap = {
    'minimal': MinimalHero,
    'default': DefaultHero
}

